import { useState } from 'react';

import { useSkeletonGate, type SkeletonGate } from '~/shared/lib/useSkeletonGate';

/**
 * A skeleton gate for a view the tab can hide and show again while it stays mounted. `.reveal` is
 * handed out only for a wait this showing saw: a view shown again over a warm read mounts its boxes
 * afresh, and a class kept from the last showing would replay their entrance.
 */
export function useViewGate(pending: boolean, shown: boolean): SkeletonGate {
  const gate = useSkeletonGate(shown && pending);
  const [showing, setShowing] = useState({ shown, sawWait: shown && gate.waiting });
  if (showing.shown !== shown) setShowing({ shown, sawWait: shown && gate.waiting });
  else if (shown && gate.waiting && !showing.sawWait) setShowing({ shown, sawWait: true });
  return showing.sawWait ? gate : { ...gate, reveal: '' };
}
